module.exports = __webpack_public_path__ + "8cbfb596326001b03a60bca073ee74d7.svg";